import {
  SAVE_ADVISORS,
  SAVE_ADVISORS_BY_DEPT,
  SAVE_ADVISOR_TYPES,
  SAVE_DEPARTMENTS,
  SAVE_IS_AUTOMATED_JOB_COMPLETED,
  SAVE_IS_CHECKING_AUTOMATED_JOB_STATUS,
  SAVE_PROCESSING_JOBS,
} from './actions';

const initialStateSAM = {
  advisorsByDept: {},
  advisors: [],
  departments: [],
  advisorTypes: [],
  isAutomatedJobCompleted: false,
  isCheckingAutomatedJobStatus: false,
  processingJobs: [],
};

//needs to persist across pages
export const samReducer = (state = initialStateSAM, action) => {
  const { type, payload } = action;
  switch (type) {
    case SAVE_DEPARTMENTS: {
      return { ...state, departments: [...payload.departments] };
    }
    case SAVE_ADVISORS: {
      return { ...state, advisors: [...payload.advisors] };
    }
    case SAVE_ADVISORS_BY_DEPT: {
      return { ...state, advisorsByDept: payload.advisorsByDept };
    }
    case SAVE_ADVISOR_TYPES: {
      return { ...state, advisorTypes: [...payload.advisorTypes] };
    }
    case SAVE_IS_AUTOMATED_JOB_COMPLETED: {
      return {
        ...state,
        isAutomatedJobCompleted: payload.isAutomatedJobCompleted,
      };
    }
    case SAVE_IS_CHECKING_AUTOMATED_JOB_STATUS: {
      return {
        ...state,
        isCheckingAutomatedJobStatus: payload.isCheckingAutomatedJobStatus,
      };
    }
    case SAVE_PROCESSING_JOBS: {
      return {
        ...state,
        processingJobs: payload.processingJobs,
      };
    }
    default:
      return state;
  }
};
